import React from 'react'
import { useTranslation } from 'react-i18next';
import { partners1, partners10, partners11, partners12, partners13, partners14, partners15, partners16, partners17, partners18, partners19, partners2, partners20, partners21, partners22, partners3, partners4, partners5, partners6, partners7, partners8, partners9, rightArrow, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';


  const newsItems = [
    {
      id: 1,
      imgSrc: partners1,
    },
    {
      id: 2,
      imgSrc: partners2,
    },
    {
      id: 3,
      imgSrc: partners3,
    },
    {
      id: 4,
      imgSrc: partners4,
    },
    {
      id: 5,
      imgSrc: partners5,
    },
    {
      id: 6,
      imgSrc: partners6,
    },
    {
      id: 7,
      imgSrc: partners7,
    },
    {
      id: 8,
      imgSrc: partners8,
    },
    {
      id: 9,
      imgSrc: partners9,
    },
    {
      id: 10,
      imgSrc: partners10,
    },
    {
      id: 11,
      imgSrc: partners11,
    },
    {
      id: 12,
      imgSrc: partners12,
    },
    {
      id: 13,
      imgSrc: partners13,
    },
    {
      id: 14,
      imgSrc: partners14,
    },
    {
      id: 15,
      imgSrc: partners15,
    },
    {
      id: 16,
      imgSrc: partners16,
    },
    {
      id: 17,
      imgSrc: partners17,
    },
    {
      id: 18,
      imgSrc: partners18,
    },
    {
      id: 19,
      imgSrc: partners19,
    },
    {
      id: 20,
      imgSrc: partners20,
    },
    {
      id: 21,
      imgSrc: partners21,
    },
    {
      id: 22,
      imgSrc: partners22,
    },
  
  ];

const PartnersItems = () => {


      const { t } = useTranslation();

  return (
    <div className='pt-[88px] md:pt-[104px] bg-[#FBFBFB]'>
  <div className='max-w-containerSm md:max-w-container mx-auto flex flex-wrap gap-5'>
    {newsItems.map((item) => (
      <div className='md:w-[160px] w-[110px] flex items-center'>
        <img src={item.imgSrc} className='w-full' alt='' />
      </div>
    ))}
  </div>
</div>

  )
}

export default PartnersItems